import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useGetPeriodos } from "hooks/useRequest";
import { Mutation } from "hooks/useMutation";
import { eliminarPeriodoMatricula } from "./mutations";
import {
  TIPO_ACTUALIZACION_DOCENTE,
  TIPO_DIDACTICA_UNIVERSITARIA,
  TIPO_EIDU,
} from "utilites/periodoTypes";

const DEFAULT_TAB = String(TIPO_DIDACTICA_UNIVERSITARIA);

export const useAdmin = () => {
  const { data, refetch, isLoading, isFetching } = useGetPeriodos();

  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState<string|null>(null);
  const [selectedPeriodName, setSelectedPeriodName] = useState("");
  const [selectedTab, setSelectedTab] = useState(DEFAULT_TAB);
  const mutation = Mutation(eliminarPeriodoMatricula, refetch);

  const history = useHistory();

  const handleEdit = (id: string) => {
    history.push({
      pathname: `/admin/periodo-matricula/`,
      search: `?periodo=${id}`,
    });
  };

  const handleDelete = (period: { id: string; nombre: string }) => {
    setModalVisible(true);
    setSelectedId(period.id);
    setSelectedPeriodName(period.nombre);
  };

  const handleOkDelete = () => {
    /*@ts-ignore*/
    mutation.mutate({ id: selectedId });
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
    setSelectedId(null);
    setSelectedPeriodName("");
  };

  const handleSelectedTab = (tabIndex: string) => {
    setSelectedTab(tabIndex)
  }

  const handleAddNew = () =>{
    history.push({
        pathname: "/admin/crear-periodo",
        state: { type: Number(selectedTab) },
      })
  }

  return {
    firstTypeData: data?.filter(
      (d: any) => Number(d.tipoPeriodo.id) === TIPO_DIDACTICA_UNIVERSITARIA
    ),
    secondTypeData: data?.filter(
      (d: any) => Number(d.tipoPeriodo.id) === TIPO_ACTUALIZACION_DOCENTE
    ),
    thirdTypeData: data?.filter(
      (d: any) => Number(d.tipoPeriodo.id) === TIPO_EIDU
    ),
    isLoading, 
    isFetching,
    isModalVisible,
    selectedId,
    selectedPeriodName,
    selectedTab,
    handleEdit,
    handleCancel,
    handleDelete,
    handleOkDelete,
    handleSelectedTab,
    handleAddNew
  };
};
